<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Επιθεωρητής</h4>
          <CButton color="primary" class="btn m-3 btn-primary" @click="createInspector()">Προσθήκη επιθεωρητή</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            id="inspectorsTable"
            :items="filteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            :loading="loading"
            sorter
          >
          <template #services-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #services="{item}">
            <td>
              {{ item.services }}
            </td>
          </template>
          <template #service_subcategories="{item}">
            <td>
              {{ item.service_subcategories }}
            </td>
          </template>
          <template #active-filter>
            <div class="selectFilter">
              <CSelect
                :options="statusOptions"
                :value.sync="selectedOption"
              />
            </div>
          </template>
          <template #comments="{item}">
            <td>
              {{ getCommentsText(item.comments) }}
            </td>
          </template>
          <template #active="{item}">
            <td>
              <CBadge :color="getBadge(item.active)">{{ getBadgeText(item.active) }}</CBadge>
            </td>
          </template>
          <template #show="{item}">
            <td>
              <CButton color="primary" @click="showInspector( item.id )">Προβολή</CButton>
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton color="primary" @click="editInspector( item.id )">Επεξεργασία</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton v-if="you!=item.id" color="danger" @click="deleteInspector( item.id )">Διαγραφή</CButton>
            </td>
          </template> -->
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

const fields = [
  { 
    key: 'name', 
    label: 'Ονοματεπώνυμο'
  },
  { 
    key: 'afm', 
    label: 'ΑΦΜ'
  },
  { 
    key: 'services', 
    label: 'Πρότυπο ISO'
  },
  { 
    key: 'service_subcategories', 
    label: 'EA / NACE'
  },
  { 
    key: 'comments', 
    label: 'Σχόλια'
  },
  { 
    key: 'active', 
    label: 'Ενεργός',
    sorter: false, 
    filter: true
  },
  { 
    key: 'show', 
    label: '', 
    sorter: false, 
    filter: false
  },
  { 
    key: 'edit', 
    label: '', 
    sorter: false, 
    filter: false
  },
  // { 
  //   key: 'delete', 
  //   label: '', 
  //   sorter: false, 
  //   filter: false
  // }
]

export default {
  name: 'Inspectors',
  data: () => {
    return {
      items: [],
      fields,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      selectedOption: 'Καμία επιλογή',
      statusOptions: ['Καμία επιλογή', 'Ενεργός', 'Ανενεργός'],
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      showMessage: false,
      alertIsShown: false,
      dismissSecs: 7,
      loading: true,
      dismissCountDown: 0,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    filteredItems() {
      if (this.selectedOption == "Καμία επιλογή" && this.selectedIsoOption == "Καμία επιλογή") {
        return this.items;
      }
      return this.items.filter(item => {
        const status = item.active == 1 ? 'Ενεργός' : 'Ανενεργός'
        const services = item.services;

        if (this.selectedOption == "Καμία επιλογή") {
          return services.includes(this.selectedIsoOption);
        }

        if (this.selectedIsoOption == "Καμία επιλογή") {
          return status == this.selectedOption;
        }

        return status == this.selectedOption && services.includes(this.selectedIsoOption);
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    getBadge (status) {
      return status === 1 ? 'success' : 'secondary'
    },
    getBadgeText (status) {
      return status === 1 ? 'Ενεργός' : 'Ανενεργός'
    },
    getCommentsText (comments) {
      if (!comments) {
        return '-';
      } else {
        return comments;
      }
    },
    getAllServices(services) {
      let temp = [];
      let text = '';
      temp = services.map((item) => {return item.name;});
      text = temp.join(", ");
      return text;
    },
    getAllServiceSubcategories(service_subcategories) {
      let temp = [];
      let text = '';
      temp = service_subcategories.map((item) => {return item.name;});
      text = temp.join(", ");
      return text;
    },
    inspectorLink (id) {
      return `inspectors/${id.toString()}`
    },
    editLink (id) {
      return `inspectors/${id.toString()}/edit`
    },
    showInspector ( id ) {
      const inspectorLink = this.inspectorLink( id );
      this.$router.push({path: inspectorLink});
    },
    editInspector ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    // deleteInspector ( id ) {
    //   let self = this;
    //   axios.post('/api/inspectors/' + id + '?token=' + localStorage.getItem("api_token"), {
    //     _method: 'DELETE'
    //   })
    //   .then(function (response) {
    //       self.message = 'Επιτυχής διαγραφή επιθεωρητή.';
    //       self.showAlert();
    //       self.getInspectors();
    //   }).catch(function (error) {
    //     console.log(error);
    //     self.$router.push({ path: '/login' });
    //   });
    // },
    createInspector () {
      this.$router.push({path: 'inspectors/create'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getInspectors (){
      let self = this;
      axios.get('/api/inspectors?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.items = response.data.inspectors.map((item) => {
          item.services = self.getAllServices(item.services);
          item.service_subcategories = self.getAllServiceSubcategories(item.service_subcategories);
          return item;
        });
        self.you = response.data.you;
        self.loading = false;

          axios.get('/api/services/list?token=' + localStorage.getItem("api_token"))
          .then(function (response) {
            self.services = response.data

            self.servicesOptions = ['Καμία επιλογή', ...self.services];
            self.selectedIsoOption = self.servicesOptions[0];

          }).catch(function (error) {
            console.log(error);
            self.loading = false;
            self.$router.push({ path: '/login' });
          });
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getInspectors();
  }
}
</script>
